import { crudMdActions } from "@/services/crud-md-actions";

const name = "directors";

export default {
  name,
  ...crudMdActions(name),
};
